export default "__VITE_ASSET__DkE04qL$__"